import CourseTemplateList from "./components/List"
import CourseTemplateForm from "./components/Form"
import CourseTemplateView from "./components/View"
import CourseTemplatePreview from "./components/Preview"

let module = "coursetemplates"

export default [
  { path: "coursetemplates", component: CourseTemplateList, meta: { module: module, permissions: ["coursetemplate-access"] } },
  {
    path: "coursetemplates/create",
    component: CourseTemplateForm,
    props: true,
    meta: { module: module, permissions: ["coursetemplate-create"] }
  },
  {
    path: "coursetemplates/edit/:id",
    component: CourseTemplateForm,
    props: true,
    meta: { module: module, permissions: ["coursetemplate-edit"] }
  },
  {
    path: "coursetemplates/view/:id",
    component: CourseTemplateView,
    props: true,
    meta: { module: module, permissions: ["coursetemplate-access"] }
  },
  {
    path: "coursetemplates/preview/:id",
    component: CourseTemplatePreview,
    props: true,
    meta: { module: module, permissions: ["coursetemplate-access"] }
  }
]
